import React from 'react';
import { SubMenuItemModel } from './types.ts';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { Link } from '@tanstack/react-router';
import { isNotNullOrUndefined } from '@utils/utils.tsx';

const SubMenuItem: React.FC<SubMenuItemModel> = ({ title, onClick, active = false, url }) => {
  const checkIsActive = (url: string) => {
    const pathWithoutParams = url?.indexOf('?') > -1 ? url.split('?')[0] : url;

    if (isNotNullOrUndefined(url)) {
      try {
        const isActive = pathWithoutParams === location.pathname;
        return isActive;
      } catch (e) {
        // console.log("error", e);
      }
    }
    return false;
  };

  const isActive = checkIsActive(url);

  return (
    <li>
      <Link
        to={url}
        onClick={onClick !== undefined ? onClick : () => {}}
        className={twMerge(
          clsx(
            'flex items-center py-2.5 pl-12 pr-4 text-[13px] text-gray-500 transition-all duration-150 border-l-[3px] border-transparent',
            'hover:text-gray-700 hover:bg-gray-100/50',
            {
              'text-primary font-medium border-l-[3px] border-primary bg-primary/5': isActive || active,
            },
          ),
        )}
      >
        {title}
      </Link>
    </li>
  );
};

export default SubMenuItem;
